// Header.jsx (sende paylaştığın dosya; sadece alt taraftaki MobileMenu içeriğini güncelledim)
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../images/logos/logo_1.png";
import MobileMenu from "../MobileMenu/MobileMenu";
import LanguageSwitcher from "../LanguageSwitcher";
import { useTranslation } from "react-i18next";

const Header = ({ hclass = "" }) => {
  const { t } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isSticky, setSticky] = useState(false);

  const ClickHandler = () => window.scrollTo(10, 0);

  useEffect(() => {
    const onScroll = () => setSticky(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div>
      <header
        className={`header header--styleOne sticky-on ${isSticky ? "sticky" : ""} ${hclass}`}
      >
        <div id="sticky-placeholder" />
        <div className="container container--custom">
          <div className="row">
            <div className="col-12">
              <div className="header__wrapper">
                {/* Left: Logo */}
                <div className="header__logo">
                  <Link onClick={ClickHandler} to="/home" className="header__logo__link" aria-label="Logo">
                    <img
                      src={logo}
                      alt="KAED Logo"
                      className="logo-img"
                      style={{ maxWidth: 300, height: "auto", display: "block", objectFit: "contain" }}
                    />
                  </Link>
                </div>

                {/* Center: Desktop menu */}
                <div className="header__menu desktop-only">
                  <nav className="mainMenu" aria-label="Primary">
                    <ul>
                      <li><Link onClick={ClickHandler} to="/home">{t("menu_home")}</Link></li>
                      <li><Link onClick={ClickHandler} to="/about">{t("menu_about")}</Link></li>
                      <li><Link onClick={ClickHandler} to="/events">{t("menu_events")}</Link></li>
                      <li><Link onClick={ClickHandler} to="/announcements">{t("menu_announcements")}</Link></li>
                      <li><Link onClick={ClickHandler} to="/blog">{t("menu_blog")}</Link></li>
                      <li><Link onClick={ClickHandler} to="/contact">{t("menu_contact")}</Link></li>
                    </ul>
                  </nav>
                </div>

                {/* Right: actions / donate (desktop) + hamburger (mobile) */}
                <div className="header__right">
                  <div className="header__actions desktop-only" style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <LanguageSwitcher />
                  </div>

                  {/* Mobile hamburger */}
                  <button
                    className="mobile-menu-toggle mobile-only"
                    aria-label="Open menu"
                    aria-controls="mobileMenu"
                    aria-expanded={mobileOpen ? "true" : "false"}
                    onClick={() => setMobileOpen((s) => !s)}
                  >
                    ☰
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile drawer/menu (sağdan açılır) */}
      <MobileMenu open={mobileOpen} onClose={() => setMobileOpen(false)} title="Menü">
        <ul id="mobileMenu" className="mobile-menu-list text-lg">
          <li><Link onClick={() => setMobileOpen(false)} to="/home">{t("menu_home")}</Link></li>
          <li><Link onClick={() => setMobileOpen(false)} to="/about">{t("menu_about")}</Link></li>
          <li><Link onClick={() => setMobileOpen(false)} to="/events">{t("menu_events")}</Link></li>
          <li><Link onClick={() => setMobileOpen(false)} to="/announcements">{t("menu_announcements")}</Link></li>
          <li><Link onClick={() => setMobileOpen(false)} to="/blog">{t("menu_blog")}</Link></li>
          <li><Link onClick={() => setMobileOpen(false)} to="/contact">{t("menu_contact")}</Link></li>

          {/* Dil anahtarı */}
          <li className="mt-4">
            <LanguageSwitcher />
          </li>
        </ul>
      </MobileMenu>
    </div>
  );
};

export default Header;
